export function brandLogo(brand?: string | null): string {
    return brand
        ? `https://storage.googleapis.com/merk_logos/${brand?.toLowerCase().replace(' ', '-')}.png`
        : 'https://storage.googleapis.com/merk_logos/onbekend.jpg';
}
